import { apiFetch } from "./client";
import { auth } from "../firebase";

export function getRevenueReport({ start, end, groupBy = "month" } = {}) {
  const params = new URLSearchParams();
  if (start) params.set("start", start);
  if (end) params.set("end", end);
  params.set("group_by", groupBy);
  return apiFetch(`/api/admin/reports/revenue?${params}`);
}

export async function downloadBookingsCsv({ start, end } = {}) {
  const base = (process.env.REACT_APP_API_BASE_URL || "http://localhost:5000").replace(/\/$/, "");
  const params = new URLSearchParams();
  if (start) params.set("start", start);
  if (end) params.set("end", end);

  const token = await auth.currentUser?.getIdToken();
  const res = await fetch(`${base}/api/admin/reports/bookings.csv?${params}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `CSV export failed (${res.status})`);
  }
  const blob = await res.blob();
  const filename =
    (res.headers.get("content-disposition") || "")
      .match(/filename="([^"]+)"/)?.[1] || "birdiebus-bookings.csv";

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
